module.exports = __webpack_public_path__ + "img/slide2.ef39b26c.png";